export default "__VITE_ASSET__BFInofKq__"